module.exports = __webpack_public_path__ + "img/1566590623.a964dd83.jpg";